'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import LoadingErrorPage from './LoadingErrorPage';

var LoadingWrapper = function LoadingWrapper(_ref) {
  var ErrorComponent = _ref.ErrorComponent,
      children = _ref.children,
      requestStatus = _ref.requestStatus;

  if (requestStatus === RequestStatusTypes.SUCCEEDED) {
    return children;
  } else if (requestStatus === RequestStatusTypes.UNINITIALIZED || requestStatus === RequestStatusTypes.PENDING) {
    return React.createElement(UILoadingSpinner, {
      grow: true,
      minHeight: 300
    });
  }

  return React.createElement(ErrorComponent, null);
};

LoadingWrapper.propTypes = {
  ErrorComponent: PropTypes.func,
  children: PropTypes.node.isRequired,
  requestStatus: PropTypes.string.isRequired
};
LoadingWrapper.defaultProps = {
  ErrorComponent: LoadingErrorPage
};
export default LoadingWrapper;